//#region ENUM SettingsReferenceEnum
export enum SettingsReferenceEnum {
  undefined = 0,
  account = 100,
  accountUserProfile = 101,
  application = 200,
  applicationUserTableSettings = 201,
  applicationPreferences = 202,
  applicationStoreDisplayOrder = 203,
  applicationEmailSettings = 204,
  feature = 300,
  featureAutoOrder = 400,
  featureAutoOrderOrderSettings = 401,
  featureAutoOrderOpenOrderSettings = 402,
  featureAutoOrderGeneralSettings = 403,
  featureAutoOrderSchedulerSettings = 404,
  featureAutoOrderDocumentLayouts = 405,
  featureEmail = 500,
  featureShelfTalkers = 600,
  featureShelfTalkerGeneral = 601,
  featureLabelMaker = 602,
  featureStockRules = 700,
  featureStockRulesStockItemRuleAdd = 701,
  featureStockRulesStockItemRuleEnable = 702,
  featureStockRulesStockItemRuleDisable = 703,
  featureStockRulesStockTags = 704,
  featureStockRulesStockThreshold = 705,
  featureStockRulesAdvancedFilters = 706,
  featureStockRulesPriceBanding = 707,
  featureStockRulesMultiplePriceChanges = 708,
  featureLocalStorage = 800,
  featureLocalStorageManager = 801,
  featureCopySettings = 900,
  featureStockTake = 1000,
  featureStockTakeGeneral = 1001,
}

//#endregion